<template>
  <section class="section" id="about">
    <div class="section-heading is-half">
      <h2 class="title is-size-2 is-uppercase">About</h2>
    </div>
    <div class="column is-10 is-offset-1">
      <div class="columns is-full-height">
        <div class="column">
          <div class="card is-borderless is-paddingless">
            <div class="card-content is-paddingless">
              <div
                class="content is-size-4 is-size-5-mobile has-text-left-mobile has-text-justified"
              >
                <p>
                  Company based from Split, Croatia, with 10 years of experience.
                  Offering clients a full service approach to all Phases of software development - from the idea and design through the implementation,
                  testing and putting applications live, always putting clients at first place.
                  <br>
                  <br>You can choose from our many services, UI/UX design, web or mobile development, consulting or implementation.
                  Our vivid team, enthusiasm, know-how and the newest technologies will be the perfect partner to your ideas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-full-height">
        <div class="column" v-for="aboutImage in aboutImages" :key="aboutImage.alt">
          <div class="card is-borderless">
            <div class="card-image">
              <figure class="image" data-aos="zoom-in" data-aos-easing="ease-out-back">
                <picture>
                  <source :srcset="aboutImage.newImageFormat" type="image/webp">
                  <img :src="aboutImage.traditionalImageFormat" :alt="aboutImage.alt">
                </picture>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'DropPage',
  data () {
    return {
      aboutImages: [
        {
          traditionalImageFormat: require('@/assets/images/del.jpg'),
          newImageFormat: require('@/assets/images/del.webp'),
          alt: 'DelCasa Magazine',
        },
        {
          traditionalImageFormat: require('@/assets/images/kam.jpg'),
          newImageFormat: require('@/assets/images/kam.webp'),
          alt: 'Teen Kam Museum',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma';

.section-heading {
  text-align: center;
  margin: 5em 0;
  @include mobile {
    margin: 3em 0;
  }
}

.is-horizontal-center {
  justify-content: center;
}

.is-borderless {
  box-shadow: none;
}

.is-full-height {
  height: 100%;
}

.is-full-width {
  width: 100%;
}

h2.title {
  font-weight: 600;
  letter-spacing: 5px;
  line-height: 50px;
  text-transform: uppercase;
  &.has-text-white {
    font-weight: 400;
  }
}
</style>
